import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function ReciteScripture() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Recite Scripture and rebuke evil in the Name of the Lord" />
        <blockquote>
          “Then Jesus said to him, ‘Begone, Satan! For it is written, “You shall worship the Lord your God, and serve Him only.”’” (Matthew 4:10)
        </blockquote>

        <p>When tempted in the wilderness by Satan, Jesus responded to each temptation by quoting God’s law as given in the book of Deuteronomy. This is a simple yet powerful way to quench temptation, as it simultaneously energizes our spirits to obedience and reminds us what sin is. Therefore, it is necessary to memorize scriptures that pertain to the specific sins with which we are tempted. For example, if tempted by anger or lust, recite Matthew 5:21-22 or 5:27-30. The verses must be known by heart for immediate recall at any time to maximize their effectiveness. A vague recollection that something might be sin is not nearly as effective. You must know well the scriptures that pertain to your sin. After the final temptation, Jesus rebuked Satan and told him to “Begone!” thus ending the confrontation.</p>

        <ul>
          <li>
            <strong>Recite Scripture that pertains to the temptation.</strong><br />
            <em>Psalm 119:9-11, Matthew 4:1-11, Luke 4:1-13</em>
          </li>
          <br />
          <li>
            <strong>Articulate the reasons for resisting.</strong><br />
            <em>Genesis 39:7-9, Matthew 16:23</em>
          </li>
          <br />
          <li>
            <strong>Recognize and rebuke the demonic influences behind the temptation.</strong><br />
            <em>Matthew 4:10, 16:23, Mark 16:17, Acts 16:18, Jude 9</em>
          </li>
          <br />
          <li>
            <strong>Meditate on God’s Word when anxieties and worries increase.</strong><br />
            <em>Psalm 94:19</em>
          </li>
        </ul>

      </div>
    </PageLayout>
  );
};
